module.exports = __webpack_public_path__ + "img/address.3d80101b.svg";